import { gql } from "@apollo/client";

export const GET_PRODUCT = gql`
  query Product($where: ProductWhereInputOne!) {
    product(where: $where) {
      id
      title
      amount
      currency
      priceLak
      priceThb
      priceUsd
      description
      unit
      shop {
        id
        name
      }
      image
      isDeleted
      createdAt
      updatedAt
      note
    }
}
`;

export const GET_PRODUCTS = gql`
  query Products($where: ProductWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
    products(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      total
      data {
        id
        title
        amount
        priceLak
        currency
        priceThb
        priceUsd
        description
        unit 
        image
        isDeleted
        createdAt
        updatedAt
        note
      }
    }
}
`;